import React from 'react';
import { isRollingPeriod } from '../../utils/quarterOptions';
import {
  Box, Select, MenuItem, FormControl, InputLabel, TextField, ListSubheader, Divider,
} from '@mui/material';

// Shared filter row for the Executive Summary and Deep Dive pages, always in this order:
// Period, custom dates, Filter by Event, TEC Program, then page-specific controls (children).
export default function ExecFilterBar({
  quarterOptions, selectedQuarter, onQuarterChange,
  customStart, customEnd, onCustomStart, onCustomEnd,
  eventOptions, eventFilter, onEventFilter,
  tecProgramOptions, tecProgramFilter, onTecProgramFilter,
  children,
}) {
  const isRolling = (o) => isRollingPeriod(o.value);
  const rolling = quarterOptions.filter(isRolling);
  const byPeriod = quarterOptions.filter(o => !isRolling(o) && o.value !== 'custom');
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5, flexWrap: 'wrap' }}>
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel id="exec-period-label">Period</InputLabel>
        <Select labelId="exec-period-label" value={selectedQuarter} label="Period" onChange={onQuarterChange}>
          <ListSubheader sx={{ lineHeight: '28px', fontSize: '0.7rem', color: 'text.secondary', pointerEvents: 'none' }}>
            Rolling Periods
          </ListSubheader>
          {rolling.map(opt => (
            <MenuItem key={opt.value} value={opt.value} sx={{ pl: 2, fontSize: '0.875rem' }}>{opt.label}</MenuItem>
          ))}
          <Divider />
          <ListSubheader sx={{ lineHeight: '28px', fontSize: '0.7rem', color: 'text.secondary', pointerEvents: 'none' }}>
            By Year / Quarter
          </ListSubheader>
          {byPeriod.map(opt => (
            <MenuItem
              key={opt.value} value={opt.value}
              sx={opt.value.startsWith('FY-') ? { fontWeight: 700, borderTop: '1px solid #eee' } : { pl: 3 }}
            >
              {opt.label}
            </MenuItem>
          ))}
          <Divider />
          <MenuItem value="custom" sx={{ pl: 2 }}>Custom</MenuItem>
        </Select>
      </FormControl>
      {selectedQuarter === 'custom' && (
        <>
          <TextField
            size="small" type="date" label="Start" value={customStart}
            onChange={(e) => onCustomStart(e.target.value)}
            slotProps={{ inputLabel: { shrink: true } }} sx={{ width: 160 }}
          />
          <TextField
            size="small" type="date" label="End" value={customEnd}
            onChange={(e) => onCustomEnd(e.target.value)}
            slotProps={{ inputLabel: { shrink: true } }} sx={{ width: 160 }}
          />
        </>
      )}
      {eventOptions.length > 0 && (
        <FormControl size="small" sx={{ minWidth: 180 }}>
          <InputLabel id="exec-event-filter-label">Filter by Event</InputLabel>
          <Select labelId="exec-event-filter-label" value={eventFilter} label="Filter by Event" onChange={e => onEventFilter(e.target.value)}>
            <MenuItem value="">All Events</MenuItem>
            {eventOptions.map(e => (
              <MenuItem key={e.id} value={String(e.id)}>{e.title}</MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {tecProgramOptions.length > 0 && (
        <FormControl size="small" sx={{ minWidth: 180 }}>
          <InputLabel id="exec-tec-program-filter-label">TEC Program</InputLabel>
          <Select labelId="exec-tec-program-filter-label" value={tecProgramFilter} label="TEC Program" onChange={e => onTecProgramFilter(e.target.value)}>
            <MenuItem value="">All Programs</MenuItem>
            {tecProgramOptions.map(t => (
              <MenuItem key={t.id} value={String(t.id)}>{t.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {children}
    </Box>
  );
}
